import styled from '@emotion/styled';
import { themed, ITheme } from '../../../themer';

export const SelectPlaceholder = styled.div<{}, ITheme>`
	color: ${themed(({ select }) => select.placeholder.color)};
`;
